"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _cnbuilder = require("cnbuilder");
var _reactI18next = require("react-i18next");
var _PasswordCriteriaModule = _interopRequireDefault(require("./PasswordCriteria.module.scss"));
var _Requirement = _interopRequireDefault(require("./Requirement"));
var _jsxRuntime = require("react/jsx-runtime");
const PasswordCriteria = _ref => {
  let {
    classNameRoot,
    classNameItem,
    testAttrRoot,
    testAttrItem,
    i18nLengthLabel,
    i18nLetterCaseLabel,
    i18nNumberAndSymbolLabel,
    i18nNameUsageLabel,
    value,
    minChars,
    onUpdate,
    i18nValidA11yText,
    i18nInvalidA11yText,
    firstName,
    lastName,
    username,
    companyName
  } = _ref;
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const [isMinLength, setIsMinLength] = (0, _react.useState)(false);
  const [isLowercase, setIsLowercase] = (0, _react.useState)(false);
  const [isUppercase, setIsUppercase] = (0, _react.useState)(false);
  const [isNumeric, setIsNumeric] = (0, _react.useState)(false);
  const [isSpecial, setIsSpecial] = (0, _react.useState)(false);
  const [isNoNameUsage, setIsNoNameUsage] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    const minimum = value.length >= minChars;
    const lower = /[a-z]/.test(value);
    const upper = /[A-Z]/.test(value);
    const numeric = /[0-9]/.test(value);
    // This regex does not include the characters "]", "\", and "/"
    const special = /[~`!@#$%^&*()_+=;:'",[<.>?[|{}-]/.test(value);
    const nameUsage = new RegExp("(".concat(firstName, "|").concat(lastName, "|").concat(username, "|").concat(companyName, ")"), 'i').test(value);
    const fulfilled = [minimum, lower && upper, numeric && special, value && !nameUsage].filter(Boolean);
    setIsMinLength(minimum);
    setIsLowercase(lower);
    setIsUppercase(upper);
    setIsNumeric(numeric);
    setIsSpecial(special);
    setIsNoNameUsage(!nameUsage);
    if (onUpdate) {
      onUpdate({
        isFulfilled: fulfilled.length === 4,
        numFulfilled: fulfilled.length
      });
    }
  }, [value, minChars, onUpdate, firstName, lastName, username, companyName]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("ul", {
    className: (0, _cnbuilder.cnb)(_PasswordCriteriaModule.default.root, classNameRoot),
    "data-test": testAttrRoot,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Requirement.default, {
      className: classNameItem,
      testAttr: testAttrItem,
      label: i18nLengthLabel || t('ui:passwordCriteria.length', {
        minChars
      }),
      isValid: isMinLength,
      i18nValidA11yText: i18nValidA11yText,
      i18nInvalidA11yText: i18nInvalidA11yText
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Requirement.default, {
      className: classNameItem,
      testAttr: testAttrItem,
      label: i18nLetterCaseLabel || t('ui:passwordCriteria.lettercase'),
      isValid: isLowercase && isUppercase,
      i18nValidA11yText: i18nValidA11yText,
      i18nInvalidA11yText: i18nInvalidA11yText
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Requirement.default, {
      className: classNameItem,
      testAttr: testAttrItem,
      label: i18nNumberAndSymbolLabel || t('ui:passwordCriteria.numberAndSymbol'),
      isValid: isNumeric && isSpecial,
      i18nValidA11yText: i18nValidA11yText,
      i18nInvalidA11yText: i18nInvalidA11yText
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Requirement.default, {
      className: classNameItem,
      testAttr: testAttrItem,
      label: i18nNameUsageLabel || t('ui:passwordCriteria.nameUsage'),
      isValid: value.length >= 1 && isNoNameUsage,
      i18nValidA11yText: i18nValidA11yText,
      i18nInvalidA11yText: i18nInvalidA11yText
    })]
  });
};
PasswordCriteria.defaultProps = {
  testAttrRoot: 'password-criteria-root',
  testAttrItem: 'password-criteria-item',
  minChars: 8
};
var _default = exports.default = PasswordCriteria;